import { Deserializable } from 'rome-library';

export class ExternalUserResetPasswordDto implements Deserializable {
  public EmailAddress: string;
  public OldPassword: string;
  public NewPassword: string;
  public ConfirmedNewPassword?: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
